/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentScope } from '../../models/attachment-scope';
import { StorageObjectDtoPage } from '../../models/storage-object-dto-page';

export interface ListStorageObjects$Params {
  assetId?: string | null;
  contentType?: string;
  name?: string;
  scopes?: Array<AttachmentScope>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'tenantId' | '-tenantId' | 'name' | '-name' | 'contentType' | '-contentType' | 'contentLength' | '-contentLength' | 'assetId' | '-assetId' | 'scope' | '-scope' | 'tags' | '-tags' | 'createdAt' | '-createdAt'>;
}

export function listStorageObjects(http: HttpClient, rootUrl: string, params?: ListStorageObjects$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listStorageObjects.PATH, 'get');
  if (params) {
    rb.query('assetId', params.assetId, {});
    rb.query('contentType', params.contentType, {});
    rb.query('name', params.name, {});
    rb.query('scopes', params.scopes, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageObjectDtoPage>;
    })
  );
}

listStorageObjects.PATH = '/v0/storageObjects';
